var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoughtPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finance_Initial-(Desktop)",
    transform: "translate(-875.000000, -702.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(845.000000, 297.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transactions_BoughtPlayer",
    transform: "translate(30.000000, 405.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    stroke: "transparent",
    mask: "url(#mask-2)",
    strokeWidth: 1.6,
    strokeDasharray: "0,0",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-68-Copy",
    opacity: 0.699999988,
    transform: "translate(6.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-66",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.94482218,8 C8.21460101,8 10.0604683,6.206 10.0604683,4 C10.0604683,1.794 8.21391507,0 5.94482218,0 C3.67572928,0 1.82917605,1.794 1.82917605,4 C1.82917605,6.206 3.67504334,8 5.94482218,8 Z M5.94482218,1.33333333 C7.45800807,1.33333333 8.68858626,2.52933333 8.68858626,4 C8.68858626,5.47066667 7.45800807,6.66666667 5.94482218,6.66666667 C4.43163629,6.66666667 3.2010581,5.47066667 3.2010581,4 C3.2010581,2.52933333 4.43163629,1.33333333 5.94482218,1.33333333 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3815399,10.9786603 C10.9606912,10.3125134 8.6610788,8.83092385 6.40211619,8.89064174 C4.14315358,8.95035964 2.75148727,9.74874128 1.57634328,11.0973865 C1.5336625,11.0554413 0.765408558,12.2192433 0.783192214,12.2270636 C0.283827151,13.1377724 0,14.1807152 0,15.2890642 C0,15.6815008 0.318683117,16 0.711346243,16 C1.10400937,16 1.42269249,15.6815008 1.42269249,15.2890642 C1.42269249,12.5448519 3.65631969,10.3125134 6.40211619,10.3125134 C9.14791269,10.3125134 11.3815399,12.5448519 11.3815399,15.2890642 C11.3815399,15.6815008 11.700223,16 12.0928861,16 C12.4855493,16 12.8042324,15.6815005 12.8042324,15.2890642 C12.8042324,12.5051315 11.4822513,11.1380728 11.3815399,10.9786603 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-67",
    transform: "translate(8.571429, 8.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 5.71428571,
    cy: 6,
    rx: 5.71428571,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71385227,1 C3.0855201,1 0.952380952,3.23971251 0.952380952,5.99935827 C0.952380952,8.75900404 3.0855201,10.9987165 5.71385227,10.9987165 C8.34218444,10.9987165 10.4753236,8.75900404 10.4753236,5.99935827 C10.4753236,3.23971251 8.34218444,1 5.71385227,1 Z M7.88508319,6.45929924 L6.15190763,6.45929924 L6.15190763,6.5592864 L6.15190763,8.27906565 C6.15190763,8.53903228 5.96144878,8.73900661 5.71385227,8.73900661 C5.46625576,8.73900661 5.27579691,8.53903228 5.27579691,8.27906565 L5.27579691,6.45929924 L3.54262135,6.45929924 C3.29502484,6.45929924 3.10456599,6.2593249 3.10456599,5.99935827 C3.10456599,5.73939164 3.29502484,5.53941731 3.54262135,5.53941731 L5.27579691,5.53941731 L5.27579691,3.7196509 C5.27579691,3.45968427 5.46625576,3.25970994 5.71385227,3.25970994 C5.96144878,3.25970994 6.15190763,3.45968427 6.15190763,3.7196509 L6.15190763,5.53941731 L7.88508319,5.53941731 C8.1326797,5.53941731 8.32313855,5.73939164 8.32313855,5.99935827 C8.32313855,6.2593249 8.11363382,6.45929924 7.88508319,6.45929924 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoughtPlayer);
export default __webpack_public_path__ + "static/media/bought-player.95ed04a203849060a4e114f28cce7960.svg";
export { ForwardRef as ReactComponent };